// LEASE_OPTIONAL_MONTH_V1
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import API from '../utils/api';

const TYPE_NAMES={
  basic_update:'房屋资料变更',member_add:'新增户内人员',member_update:'户内人员资料变更',member_remove:'移除户内人员',
  parking_add:'新增车位',parking_update:'车位资料变更',parking_remove:'移除车位',vehicle_add:'新增车辆',vehicle_update:'车辆资料变更',vehicle_remove:'移除车辆',face_update:'门禁人脸',access_revoke:'门禁注销',account_registration:'账户注册'
};
const FIELD_NAMES={
  owner_name:'业主姓名',contact_phone:'联系电话',occupancy_status:'入住状态',member_type:'成员身份',relationship:'与业主关系',
  real_name:'姓名',gender:'性别',phone:'手机号',id_card_no:'身份证号',resident_status:'居住状态',workplace:'工作单位',note:'备注',is_primary:'主要联系人',
  member_id:'关联人员',space_no:'车位号',parking_space_id:'车位',plate_no:'车牌号',vehicle_type:'车辆类型',brand_model:'品牌型号',vehicle_color:'车辆颜色',face_photo:'人脸照片'
};
const statusText={pending:'待审核',approved:'已通过',rejected:'已拒绝'};

function fmt(v){
  if(v===null||v===undefined||v==='') return '—';
  if(typeof v==='object') return JSON.stringify(v);
  if(v===1||v==='1') return '是';
  if(v===0||v==='0') return '否';
  return String(v);
}
const accountText=v=>v==='tenant'?'租户':v==='owner'?'业主':(v||'—');
const residentText=v=>['租客','租户','tenant'].includes(v)?'租户':(v||'—');
const maskPhone=v=>{const x=String(v||'');return x.length>=7?x.slice(0,3)+'****'+x.slice(-4):x||'—';};
const maskId=v=>{const x=String(v||'');return x.length>=10?x.slice(0,6)+'********'+x.slice(-4):x||'—';};

function SensitiveId({value}){
  const [show,setShow]=useState(false);
  if(!value)return <span style={s.value}>—</span>;
  return <span style={s.value}>{show?String(value):maskId(value)} <button type="button" style={s.miniLink} onClick={()=>setShow(!show)}>{show?'隐藏':'查看完整'}</button></span>;
}

function RegistrationBlock({data,property}){
  const d=data||{},modern=d.parking_vehicle_schema==='two_plates_per_space_v1';
  const p1=[d.registration_plate_no,modern?d.registration_plate_no_2:null].filter(Boolean).join('、')||'—';
  const p2=[modern?d.registration_plate_no_3:d.registration_plate_no_2,modern?d.registration_plate_no_4:null].filter(Boolean).join('、')||'—';
  const roomNo=property?.room_no||d.room_no||d.registration_room_no||'—';

  const unitMatch=String(roomNo).match(/^(.+?幢\d+单元)/);
  const unitName=unitMatch?unitMatch[1]:'本单元';

  const rows=[
    ['账户类型',accountText(d.account_type)],
    ['人员身份',residentText(d.resident_type)],
    ['申请绑定房屋',roomNo],
    ['登录账号',d.username||'—'],
    ['姓名',d.real_name||'—'],
    ['手机号',maskPhone(d.phone)],
    ['身份证号',null],
    ['工作单位/地点',d.workplace||'—'],
    ['车位1',d.registration_parking_space_no||'—'],
    ['车牌1/2',p1],
    ['车位2',d.registration_parking_space_no_2||'—'],
    ['车牌3/4',p2]
  ];

  const isTenant=d.account_type==='tenant';
  const missingId=isTenant&&!d.id_card_photo;
  const missingFace=!d.face_photo;

  return <div style={s.card}>
    <div style={s.cardTitle}>申请内容</div>

    {rows.map(([k,v])=>
      <div key={k} style={s.row}>
        <span style={s.label}>{k}</span>
        {k==='身份证号'
          ? <SensitiveId value={d.id_card_no}/>
          : <span style={{
              ...s.value,
              ...(k==='申请绑定房屋'?s.roomValue:{})
            }}>{v}</span>}
      </div>
    )}

    <div style={s.verifySection}>
      <div style={s.sectionTitle}>证件与人脸核验</div>

      <div style={s.photoGrid}>
        <div style={s.verifyCard}>
          <div style={s.verifyHead}>
            <span style={s.verifyTitle}>身份证原件</span>
            <span style={{
              ...s.verifyStatus,
              ...(d.id_card_photo?s.okStatus:s.badStatus)
            }}>
              {d.id_card_photo?'已上传':'缺失'}
            </span>
          </div>

          {d.id_card_photo
            ? <img
                src={'/uploads/'+d.id_card_photo}
                alt="身份证照片"
                style={s.verifyImage}
              />
            : <div style={s.photoEmpty}>未上传身份证照片</div>
          }

          {isTenant&&
            <div style={s.verifyHint}>租户必须核验姓名、身份证号码及证件照片</div>
          }
        </div>

        <div style={s.verifyCard}>
          <div style={s.verifyHead}>
            <span style={s.verifyTitle}>本人正脸照片</span>
            <span style={{
              ...s.verifyStatus,
              ...(d.face_photo?s.okStatus:s.badStatus)
            }}>
              {d.face_photo?'已上传':'缺失'}
            </span>
          </div>

          {d.face_photo
            ? <img
                src={'/uploads/'+d.face_photo}
                alt="本人正脸照片"
                style={s.verifyFace}
              />
            : <div style={s.photoEmpty}>未上传本人正脸照片</div>
          }

          <div style={s.verifyHint}>请确认照片为申请人本人、清晰无遮挡</div>
        </div>
      </div>
    </div>

    {(missingId||missingFace)&&
      <div style={s.warn}>
        ⚠️
        {missingId&&missingFace
          ? ' 租户身份证照片和本人正脸照片均缺失，不能审核通过。'
          : missingId
            ? ' 租户缺少身份证照片，不能审核通过。'
            : ' 缺少本人正脸照片，暂不建议审核通过。'}
      </div>
    }

    
    {isTenant&&<div style={s.notice}>
      <b>通行期限规则：</b>
      {d.lease_contract&&d.lease_end_date
        ? '按合同至 '+d.lease_end_date+' 23:59:59'
        : '从审核通过时起1个自然月，以服务器计算并下发的期限为准。'}
      {!d.lease_contract&&' 未提供合同，所填租赁日期不用于延长通行期限。'}
    </div>}
    <div style={s.accessSection}>
      <div style={s.sectionTitle}>门禁授权预览</div>
      <div style={s.accessTip}>
        审核通过后建议按房屋关系授权以下门禁。当前页面仅作审核提示，实际权限仍以后端门禁任务为准。
      </div>

      <div style={s.accessGrid}>
        {['东大门','西大门',unitName+'门禁'].map(name=>
          <div key={name} style={s.accessItem}>
            <span style={s.checkMark}>✓</span>
            <span>{name}</span>
          </div>
        )}
      </div>
    </div>
  </div>;
}

function DataBlock({title,data,face}){
  const entries=Object.entries(data||{}).filter(([k])=>k!=='face_photo');
  return <div style={s.card}>
    <div style={s.cardTitle}>{title}</div>
    {entries.length?entries.map(([k,v])=><div key={k} style={s.row}><span style={s.label}>{FIELD_NAMES[k]||k}</span><span style={s.value}>{fmt(v)}</span></div>):<div style={s.empty}>无</div>}
    {face&&<div style={{marginTop:12}}><div style={{...s.label,marginBottom:8}}>人脸照片</div><img src={'/uploads/'+face} alt="待审核人脸" style={s.face}/></div>}
  </div>;
}

export default function ReviewTaskDetail(){
  const {requestId}=useParams();
  const navigate=useNavigate();
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const load=()=>API.get('/property-archive/review-tasks/'+requestId).then(r=>setData(r.data)).catch(e=>alert(e.response?.data?.message||'读取审核任务失败')).finally(()=>setLoading(false));
  useEffect(()=>{load();},[requestId]);

  const review=async(decision)=>{
    if(!data||data.request.status!=='pending') return;
    let review_note='';
    if(decision==='rejected'){
      review_note=window.prompt('请输入拒绝原因','资料需要进一步核实')||'';
      if(!review_note) return;
    }else{
      const risky=['face_update','access_revoke'].includes(data.request.change_type);
      const msg=data.request.change_type==='account_registration'
        ? ((data.request.requested?.account_type==='tenant')?'请确认已核验租户身份及房屋关系。有合同和到期日期的按合同期限授权；否则从本次审核通过起临时通行1个月。通过后会启用租户账号并创建该房屋门禁人脸同步任务。':'请确认已核验业主身份及房屋关系。通过后会启用账号并创建该房屋门禁人脸同步任务。')
        : risky
          ? (data.request.change_type==='face_update'?'确认通过门禁人脸审核？通过后会创建 AJB 人脸注册任务。':'确认通过门禁注销审核？通过后会创建 AJB 注销任务。')
          : '确认审核通过？通过后申请内容将正式生效。';
      if(!window.confirm(msg)) return;
    }
    setSaving(true);
    try{
      const r=await API.post(`/property-archive/properties/${data.property.id}/change-requests/${requestId}/review`,{decision,review_note});
      const access=r.data?.access||[];
      const failed=access.filter(x=>x.error);
      alert(r.data.message+(access.length?`\n门禁任务：${access.length}项${failed.length?`，失败${failed.length}项`:''}`:''));
      navigate('/tasks');
    }catch(e){alert(e.response?.data?.message||'审核失败');}
    finally{setSaving(false);}
  };

  if(loading) return <div style={s.page}><div style={s.loading}>加载中...</div></div>;
  if(!data) return <div style={s.page}><div style={s.loading}>审核任务不存在</div></div>;
  const r=data.request, requested=r.requested||{}, before=r.before||{};
  return <div style={s.page}>
    <div style={s.header}><button style={s.back} onClick={()=>navigate('/tasks')}>← 返回</button><div><div style={s.title}>{r.change_type==='account_registration'?'账户注册审核':'业主变更审核'}</div><div style={s.sub}>{data.property.room_no}</div></div><div style={{width:50}}/></div>
    <div style={s.wrap}>
      <div style={s.hero}>
        <div><div style={s.heroTitle}>{TYPE_NAMES[r.change_type]||r.change_type}</div><div style={s.muted}>申请人：{r.requester_name||'业主'} · {new Date(r.created_at).toLocaleString('zh-CN')}</div></div>
        <span style={{...s.tag,background:r.status==='pending'?'#fff7e6':r.status==='approved'?'#f6ffed':'#fff1f0',color:r.status==='pending'?'#d46b08':r.status==='approved'?'#389e0d':'#cf1322'}}>{statusText[r.status]||r.status}</span>
      </div>
      <div style={s.notice}>{r.change_type==='account_registration'?'注册申请未审核前账号不可登录。租户须核验身份证照片；未提供合同或合同到期日期的，临时通行1个月；账户审核通过后才会绑定房屋并创建门禁人脸同步任务。':'此任务来自业主端提交。未审核前不会修改正式房屋档案；门禁人脸只有审核通过后才会创建 AJB 下发任务。'}</div>
      <DataBlock title="变更前" data={before}/>
      {r.change_type==='account_registration'?<RegistrationBlock data={requested} property={data.property}/>:<DataBlock title="申请内容" data={requested} face={requested.face_photo}/>}
      {data.target&&<DataBlock title="当前对象资料" data={data.target}/>} 
      {r.review_note&&<div style={s.card}><div style={s.cardTitle}>审核备注</div><div>{r.review_note}</div></div>}
      {r.status==='pending'&&<div style={s.actions}>
        <button disabled={saving} style={{...s.btn,background:'#1677ff'}} onClick={()=>review('approved')}>{saving?'处理中...':'通过'}</button>
        <button disabled={saving} style={{...s.btn,background:'#cf1322'}} onClick={()=>review('rejected')}>拒绝</button>
      </div>}
    </div>
  </div>;
}

const s={
  page:{minHeight:'100vh',background:'#f5f7fa',paddingBottom:30},
  header:{background:'linear-gradient(90deg,#1a4a8a,#2d7dd2)',color:'#fff',padding:'14px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,zIndex:10},
  back:{border:0,background:'transparent',color:'#fff',fontSize:15,cursor:'pointer'},
  title:{fontSize:18,fontWeight:800,textAlign:'center'},
  sub:{fontSize:12,opacity:.85,textAlign:'center',marginTop:2},
  wrap:{maxWidth:760,margin:'0 auto',padding:16},
  hero:{background:'#fff',borderRadius:12,padding:16,display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',boxShadow:'0 2px 8px rgba(0,0,0,.06)',marginBottom:12},
  heroTitle:{fontSize:18,fontWeight:800,color:'#222',marginBottom:5},
  muted:{fontSize:12,color:'#888'},
  tag:{padding:'5px 10px',borderRadius:12,fontSize:12,fontWeight:700,whiteSpace:'nowrap'},
  notice:{background:'#fffbe6',border:'1px solid #ffe58f',color:'#8a6d1d',borderRadius:10,padding:12,fontSize:13,lineHeight:1.6,marginBottom:12},
  card:{background:'#fff',borderRadius:12,padding:16,boxShadow:'0 2px 8px rgba(0,0,0,.05)',marginBottom:12},
  cardTitle:{fontSize:15,fontWeight:800,color:'#1a4a8a',marginBottom:10},
  row:{display:'flex',gap:12,padding:'8px 0',borderBottom:'1px solid #f0f0f0',alignItems:'center'},
  label:{width:110,flexShrink:0,fontSize:13,color:'#777'},
  value:{fontSize:13,color:'#222',wordBreak:'break-all'},
  roomValue:{fontWeight:800,color:'#1677ff'},
  face:{width:150,height:190,objectFit:'cover',borderRadius:10,border:'1px solid #eee'},
  idCard:{width:'100%',maxWidth:430,maxHeight:280,objectFit:'contain',borderRadius:10,border:'1px solid #eee',background:'#fafafa'},
  photoBlock:{marginTop:14,paddingTop:12,borderTop:'1px solid #f0f0f0'},
  photoTitle:{fontSize:13,fontWeight:700,color:'#555',marginBottom:8},
  verifySection:{marginTop:18,paddingTop:15,borderTop:'1px solid #edf0f5'},
  sectionTitle:{fontSize:14,fontWeight:800,color:'#1a4a8a',marginBottom:10},
  photoGrid:{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))',gap:12},
  verifyCard:{border:'1px solid #e8ecf2',borderRadius:12,padding:12,background:'#fafcff'},
  verifyHead:{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8,marginBottom:10},
  verifyTitle:{fontSize:13,fontWeight:800,color:'#333'},
  verifyStatus:{fontSize:11,padding:'3px 8px',borderRadius:10,fontWeight:700},
  okStatus:{background:'#f6ffed',color:'#389e0d'},
  badStatus:{background:'#fff1f0',color:'#cf1322'},
  verifyImage:{width:'100%',height:210,objectFit:'contain',borderRadius:8,border:'1px solid #eee',background:'#fff'},
  verifyFace:{width:'100%',height:210,objectFit:'contain',borderRadius:8,border:'1px solid #eee',background:'#fff'},
  photoEmpty:{height:210,display:'flex',alignItems:'center',justifyContent:'center',border:'1px dashed #d9d9d9',borderRadius:8,color:'#aaa',fontSize:13,background:'#fff'},
  verifyHint:{fontSize:11,color:'#888',lineHeight:1.6,marginTop:8},
  warn:{marginTop:12,background:'#fff1f0',border:'1px solid #ffccc7',color:'#cf1322',borderRadius:8,padding:10,fontSize:13},
  accessSection:{marginTop:18,paddingTop:15,borderTop:'1px solid #edf0f5'},
  accessTip:{fontSize:12,color:'#888',lineHeight:1.6,marginBottom:10},
  accessGrid:{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:8},
  accessItem:{display:'flex',alignItems:'center',gap:8,padding:'10px 12px',background:'#f0f7ff',border:'1px solid #d6eaff',borderRadius:9,fontSize:13,color:'#1a4a8a',fontWeight:700},
  checkMark:{width:20,height:20,borderRadius:6,background:'#1677ff',color:'#fff',display:'inline-flex',alignItems:'center',justifyContent:'center',fontSize:12},
  miniLink:{border:0,background:'transparent',color:'#1677ff',padding:'0 4px',fontSize:12,cursor:'pointer'},
  empty:{fontSize:13,color:'#aaa'},
  actions:{display:'flex',gap:12,position:'sticky',bottom:74,background:'rgba(245,247,250,.96)',padding:'10px 0',zIndex:8},
  btn:{flex:1,border:0,borderRadius:10,padding:13,color:'#fff',fontSize:16,fontWeight:800,cursor:'pointer'},
  loading:{padding:60,textAlign:'center',color:'#888'}
};
